module.exports = __webpack_public_path__ + "static/media/aac-icon.d2c925b1.svg";